// src/theme.js
import { createTheme } from '@mui/material/styles';

// Colore predefinito nel caso il manifest non sia disponibile
const defaultPrimaryColor = '#4CAF50'; // Verde per camper/natura
const defaultSecondaryColor = '#FF9800'; // Arancione complementare

// Funzione per ottenere il colore dal manifest o utilizzare un colore di default
const getThemeColor = async () => {
  try {
    const response = await fetch('/manifest.json');
    const manifest = await response.json();
    return manifest.theme_color || defaultPrimaryColor;
  } catch (error) {
    console.error('Errore nel caricare il manifest:', error);
    return defaultPrimaryColor;
  }
};

export const generateTheme = async () => {
  const themeColor = await getThemeColor();

  return createTheme({
    palette: {
      primary: {
        main: themeColor,
        light: '#81c784',
        dark: '#388e3c',
        contrastText: '#ffffff',
      },
      secondary: {
        main: defaultSecondaryColor,
        light: '#ffb74d',
        dark: '#f57c00',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f5f5f5',
        paper: '#ffffff',
      },
      error: {
        main: '#f44336',
      },
      success: {
        main: '#4caf50',
      },
      text: {
        primary: '#263238',
        secondary: '#546e7a',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontWeight: 500,
        fontSize: '2.5rem',
      },
      h2: {
        fontWeight: 500,
        fontSize: '2.25rem',
      },
      h3: {
        fontWeight: 500,
        fontSize: '2rem',
      },
      h4: {
        fontWeight: 500,
        fontSize: '1.75rem',
      },
      h5: {
        fontWeight: 500,
        fontSize: '1.5rem',
      },
      h6: {
        fontWeight: 500,
        fontSize: '1.25rem',
      },
      subtitle1: {
        fontSize: '1.1rem',
      },
      body1: {
        fontSize: '1rem',
      },
      button: {
        textTransform: 'none',
        fontWeight: 500,
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '8px 16px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.16)',
            '&:hover': {
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            },
          },
          contained: {
            '&:hover': {
              boxShadow: '0 6px 12px rgba(0,0,0,0.25)',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
          },
          elevation1: {
            boxShadow: '0 1px 8px rgba(0,0,0,0.1)',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: 600,
            backgroundColor: 'rgba(76, 175, 80, 0.08)',
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:nth-of-type(even)': {
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: themeColor,
              },
            },
          },
        },
      },
    },
  });
};